import { isLight } from './contrast.js';
import { withAlpha } from './opacity.js';
import { mix } from './manipulate.js';

export interface GlassOptions {
  intensity?: 'low' | 'medium' | 'high';
  base?: 'light' | 'dark' | 'auto';
}

export interface GlassStyle {
  background: string;
  backdropFilter: string;
  border: string;
}

export function glass(color: string, opts: GlassOptions = {}): GlassStyle {
  const { intensity = 'medium', base = 'auto' } = opts;
  const resolvedBase = base === 'auto' ? (isLight(color) ? 'light' : 'dark') : base;
  const alpha = { low: 0.4, medium: 0.6, high: 0.8 }[intensity];
  const blur = { low: 8, medium: 14, high: 22 }[intensity];
  const tint = resolvedBase === 'light' ? '#ffffff' : '#000000';
  const blendWeight = resolvedBase === 'light' ? 0.7 : 0.6;
  const tinted = mix(color, tint, blendWeight);
  const borderColor = resolvedBase === 'light' ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.15)';
  return {
    background: withAlpha(tinted, alpha),
    backdropFilter: `blur(${blur}px) saturate(180%)`,
    border: `1px solid ${borderColor}`
  };
}

export function glassCss(color: string, opts: GlassOptions = {}): Record<string, string> {
  const g = glass(color, opts);
  return {
    background: g.background,
    'backdrop-filter': g.backdropFilter,
    '-webkit-backdrop-filter': g.backdropFilter,
    border: g.border
  };
}
